import AppDispatcher from '../core/AppDispatcher.jsx';
import {ActionTypes} from '../constants/ErrorHandlerConstants';

export const errorHandled = (correlationId) => {
    AppDispatcher.dispatch({
        actionType: ActionTypes.ERROR_HANDLED,
        correlationId
    });
};



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/ErrorHandlerActions.js